import { paginatedQuery } from 'lib-shared-api-utils';
import moment from 'moment-timezone';

import { api } from 'app/app.api';

import {
  ReadDashboardQueuesApiArg,
  ReadDashboardQueuesApiResponse,
  ReadDashboardQueuesByIdApiArg,
  ReadDashboardQueuesByIdApiResponse,
  ReadQueueStatisticsApiArg,
  ReadQueueStatisticsApiResponse,
} from './types/statisticsApi.types';

export const statisticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readDashboardQueues: builder.query<
      ReadDashboardQueuesApiResponse,
      ReadDashboardQueuesApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, () => ({
          version: 2,
          path: 'statistics/dashboard/queue',
        })),
    }),
    readDashboardQueuesById: builder.query<
      ReadDashboardQueuesByIdApiResponse,
      ReadDashboardQueuesByIdApiArg
    >({
      query: ({ ids }) => ({
        version: 2,
        path: 'statistics/dashboard/queue',
        params: {
          queue_ids: ids.join(','),
        },
      }),
    }),
    readDashboardAgentQueues: builder.query<
      ReadDashboardQueuesApiResponse,
      ReadDashboardQueuesApiArg
    >({
      query: () => ({
        version: 2,
        path: 'statistics/dashboard/agent/queue',
      }),
    }),
    readQueueStatistics: builder.query<
      ReadQueueStatisticsApiResponse,
      ReadQueueStatisticsApiArg
    >({
      query: ({ id, dateRange: [startDate, endDate] }) => ({
        version: 1,
        path: `statistics/historic/queue/${id}`,
        params: {
          start_date: moment(startDate).format('YYYY-MM-DD'),
          end_date: moment(endDate).format('YYYY-MM-DD'),
        },
      }),
    }),
  }),
});
